


(function() {


    var xmsTimepicker = function($compile, dateFilter) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                $scope.hiddenGrails = new Object();

                $scope.xmsTimeGrails = function(time){
                    if(time.length > 0) {
                        var timeArr = time.split(':');
                        // we probably should use 1970-01-01 date as this is what Angular uses by default
                        // but we use 1900 as this is what Grails has been configured for (?)
                        return returnDate =  new Date (1900, 0, 1, timeArr[0], timeArr[1], 0);
                    } else {
                        return '';
                    }
                }

                $scope.xmsTime = function(time){
                    var timeArr = time.split(':');
                    return returnDate =  new Date (1970, 0, 1, timeArr[0], timeArr[1], 0);
                    // we want to use 1970-01-01 date as this is what Angular uses by default
                }

            }],
            require:'?ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {

                if( ngModelCtrl ){
                    ngModelCtrl.$formatters.unshift(function(value) {
                        return typeof value === 'string' ? value.replace(/:00\.000$/, '') : value; // HH:MM format
                    });

                    scope.clearModel = function(){ // for MS Edge workaround
                        element.val('');
                        ngModelCtrl.$setViewValue('');
                        ngModelCtrl.$modelValue = undefined;
                        ngModelCtrl.$$writeModelToScope();
                }
                }

                // Intentionally no wrapper or clock icon: the input stays a plain native
                // <input type="time">. Wrapping/reparenting it broke taps on older Android WebViews.

                if(cssua.ua.edge && ngModelCtrl){
                    element.after( $compile('<a ng-click="clearModel()" title="Clear Time" href="javascript:void(0);" class="clear-field">&times;<a>')(scope) );
                }

            },
        };
    }
    xmsTimepicker.$inject = ['$compile','dateFilter'];
    angular.module('app').directive('xmsTimepicker', xmsTimepicker);


}());
